/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { styleguideColors as COLORS } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { styleguideFontFamily as FONT, withOpacity } from '@kaiizen/kai-shiki/core';

/** The two styles more than one part of the manager needs: a section's photo count, and the
 *  button shape shared by the action bar and the photo stage. */
export const SECTION_COUNT_STYLE = css`
  font-family: ${FONT.body};
  font-size: ${pxToRem(12)};
  color: ${withOpacity(COLORS.white, 0.62)};
`;

export const ACTION_BUTTON_STYLE = css`
  label: PHOTO_MANAGER_ACTION_BUTTON;
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 14px;
  background: none;
  border: 1px solid ${withOpacity(COLORS.white, 0.3)};
  color: ${COLORS.white};
  font-family: ${FONT.mono};
  font-size: ${pxToRem(11)};
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;

  &:hover {
    border-color: ${COLORS.white};
  }
`;
